<form class="form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
  <div class="form-field">
    <label for="invitation-email">
      {{ "invitation.email.label" | translate }}
    </label>

    <div class="input-wrapper">
      <lucide-icon name="mail" [size]="19"></lucide-icon>

      <input
        id="invitation-email"
        type="email"
        formControlName="email"
        autocomplete="email"
        [placeholder]="'invitation.email.placeholder' | translate"
      />
    </div>

    <span *ngIf="this.form.get('email')?.invalid && this.form.get('email')?.touched" class="field-error">
      {{ "invitation.email.invalid" | translate }}
    </span>
  </div>

  <button type="submit" class="primary-button" [disabled]="form.invalid">
    {{ "invitation.email.continue" | translate }}

    <lucide-icon name="arrow-right" [size]="18"></lucide-icon>
  </button>
</form>
